import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Text } from "~/foundation/components/Text";
import { useDocumentTitle } from "~/foundation/hooks/useDocumentTitle";

export function NotFoundScene() {
  const { t } = useTranslation();
  useDocumentTitle(t("Page not found"));

  return (
    <div className="flex flex-col items-center justify-center gap-3 p-16 text-center">
      <Text as="h1" variant="h2">
        {t("Page not found")}
      </Text>
      <Text variant="secondary">{t("The page you were looking for does not exist.")}</Text>
      <Link to="/" className="text-body text-link hover:underline">
        {t("Back to home")}
      </Link>
    </div>
  );
}
